module.exports = __webpack_public_path__ + "static/img/103898.8737d1a9.png";